export enum InitialTermTypeEnum {
  Standard = 'STANDARD', Evergreen = 'EVERGREEN',
}
